import { ITransition } from '@/helpers/transition';
import { cloneDeep } from 'lodash';
import { Component } from 'vue-property-decorator';
import TransitionLibraryMixins from './TransitionLibraryMixins';

@Component({})
export default class TransitionLibraryMobileModal extends TransitionLibraryMixins {
  toggleTransitionPlaying(transition) {
    const existingTransitions = cloneDeep(this.availableTransitions);

    this.availableTransitions = existingTransitions.map((existingTransition) => {
      if (transition.id === existingTransition.id) return { ...existingTransition, ...{ playing: !existingTransition.playing } };
      return existingTransition;
    });
  }
}
